import React, { useEffect, useState, FC } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Element } from 'react-scroll';
import PositionCompanyList from '@components/position/jd/positionCompany/positionCompanyList';
import { useMatchingCompany } from '@repository/position/usePosition';
import PositionCompanyModal from './positionCompanyModal';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import { V2Route } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './positionCompany.module.scss';
const cx = classnames.bind(styles);

interface IPositionCompanyProps {
  positionDetail: PositionDetailVO;
}

export const PositionCompanyOffsetName = 'Recruitment';

const PositionCompany: FC<IPositionCompanyProps> = ({ positionDetail }) => {
  const { query } = useRouter();
  const positionSn = Number(query.sn);
  const [modalVisible, setModalVisible] = useState(false);

  const { data: positionCompanyList, isLoading } = useMatchingCompany(positionSn);

  useEffect(() => {
    setModalVisible(false);
  }, [positionSn]);

  if (!positionCompanyList || isLoading) return null;
  const { positions } = positionCompanyList;

  if (!positions || positions.length === 0) return null;
  const { companyName, companySn } = positionDetail.companyInfo;
  const companyUrl = V2Route.getCompanyChannelPage(companySn);

  return (
    <Element name={PositionCompanyOffsetName}>
      <div className={cx('positionWrap')}>
        <em className={cx('title')}>
          <Link href={companyUrl} legacyBehavior>
            <a role="button">{companyName}</a>
          </Link>
          에서 채용중<span className={cx('text')}>인 다른 포지션을 만나보세요.</span>
        </em>

        <PositionCompanyList positions={positions} setModalVisible={setModalVisible} />

        <PositionCompanyModal positions={positions} visible={modalVisible} onClose={() => setModalVisible(false)} />
      </div>
    </Element>
  );
};

export default PositionCompany;
